import getFetchOptions from './utils/getFetchOptions.js';
import fetchJSON from './utils/fetchJSON.js';
const options = {
  circuitBreaker: {
    id: 'ico',
    timeout: 5000,
    resetTimeout: 30000,
    fallback: {
      error: 'Circuit Breaker for /ico/offers is open'
    }
  },
  headers: {
    'X-fwd-svc': 'atc'
  }
};
function icoFetcher(path) {
  return {
    path: path + 'cars-for-sale/ico/offers/v1/offers',
    async fetch(query) {
      try {
        const data = await fetchJSON(this.path, getFetchOptions({
          query,
          ...options
        }));
        return data;
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Error fetching ICO data: ', error);
      }
      return {};
    }
  };
}
export { icoFetcher as default };
